import type { JSONSchema7 } from 'json-schema';
import { GlobalThemeMapping } from '../../themes';
import { WEBVIEW_THEME_VARIABLES } from '../../themes/themeVariables';

export const WEBVIEW_THEME_MAPPING: GlobalThemeMapping<
  typeof WEBVIEW_THEME_VARIABLES.colors,
  typeof WEBVIEW_THEME_VARIABLES.others,
  never
> = {
  colors: {
    background_base: [
      '--webview-root-background',
      '--webview-root-background-dark',
      '--custom-thumb-bg',
      '--tds-color-base-01',
      '--webview-checkbox-background',
      '--webview-checkbox-background-dark',
    ],
    background_base_alt: ['--color-secondary', '--color-secondary-hover'],
    background_neutral_1: '--tds-color-secondary',
    background_neutral_1_hover: ['--track-bg-color', '--tds-color-secondary-hover'],
    background_neutral_2: '--webview-answer-background-color',
    accent: [
      '--webview-button-background-color',
      '--webview-button-background-color-dark',
      '--webview-button-background-color-disabled',
      '--webview-button-background-color-disabled-dark',
      '--webview-checkbox-background-checked',
      '--webview-checkbox-background-checked-dark',
      '--tds-color-info-fill',
      '--tds-color-primary',
      '--color-primary',
      '--color-brand',
      '--color-native-blue',
      '--tui-background-accent-1',
    ],
    accent_hover: '--tds-color-primary-hover',
    accent_active: '--tds-color-primary-active',
    primary: '--tds-color-text-01',
    secondary: '--tds-color-text-02',
    tertiary: '--tds-color-text-03',
    primary_on_accent: [
      '--webview-button-color',
      '--webview-button-color-dark',
      '--webview-checkbox-check-mark',
      '--webview-checkbox-check-mark-dark',
      '--color-text-primary',
      '--tds-color-primary-text',
    ],
    positive: '--color-success',
    negative: '--color-error',
    action: ['--webview-header-actions', '--webview-header-actions-dark'],
    progress_bar_line: ['--webview-progress-bar', '--webview-progress-bar-dark'],
    progress_bar_line_filled: ['--webview-progress-bar-track', '--webview-progress-bar-track-dark'],
    border_normal: ['--tds-color-focus', '--tds-color-base-04', '--color-ui-2'],
  },
  others: {
    webview_answer_inner_padding: '--custom-webview-answer-inner-padding',
    webview_answer_border_radius: '--custom-webview-answer-border-radius',
    webview_footer_button_position: '--custom-webview-footer-button-position',
    webview_elements_border_radius: '--custom-survey-elements-border-radius',
  },
  fonts: {},
  custom: {
    '--custom-webview-answer-inner-padding': '0',
    '--custom-webview-answer-border-radius': '0',
    '--custom-webview-footer-button-position': 'normal',
    '--custom-survey-elements-border-radius': '16px',
  },
} as const;

export const createThemeWebviewColorsSchema = (): JSONSchema7 => {
  const properties: Record<string, JSONSchema7> = {};

  for (const key of Object.keys(WEBVIEW_THEME_VARIABLES.colors)) {
    const description = WEBVIEW_THEME_VARIABLES.colors[key as keyof typeof WEBVIEW_THEME_VARIABLES.colors].description;

    properties[key] = {
      type: 'object',
      description: description || ``,
      properties: {
        light: { type: 'string' },
        dark: { type: 'string' },
      },
      required: ['light', 'dark'],
      additionalProperties: false,
    };
  }

  return {
    type: 'object',
    description: 'Абстрактно объявленные названия цветов которые ссылаются на переменные webview',
    properties,
    additionalProperties: false,
    required: Object.keys(WEBVIEW_THEME_VARIABLES.colors),
  };
};

export const createThemeWebviewOthersSchema = (): JSONSchema7 => {
  const properties: Record<string, JSONSchema7> = {};

  for (const key of Object.keys(WEBVIEW_THEME_VARIABLES.others)) {
    const description = WEBVIEW_THEME_VARIABLES.others[key as keyof typeof WEBVIEW_THEME_VARIABLES.others].description;

    properties[key] = {
      type: 'string',
      description: description || ``,
    };
  }

  return {
    type: 'object',
    description: 'Дополнительные параметры стилей для вебвью',
    properties,
    additionalProperties: false,
    required: Object.keys(WEBVIEW_THEME_VARIABLES.others),
  };
};
